"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _Backdrop = _interopRequireDefault(require("../Backdrop"));
var _View = _interopRequireDefault(require("../View"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _styles = require("@mui/styles");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TRANSITION_DURATION = 500;
var useStyles = (0, _styles.makeStyles)({
  root: {
    // border: '3px solid blue',
    zIndex: "1300!important"
  }
});
var Dialog = exports.Dialog = function Dialog(_ref) {
  var children = _ref.children,
    _ref$dataCy = _ref["data-cy"],
    dataCy = _ref$dataCy === void 0 ? "Dialog" : _ref$dataCy,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onExited = _ref.onExited,
    open = _ref.open,
    active = _ref.active,
    onClose = _ref.onClose,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? "paper" : _ref$scroll,
    fullScreen = _ref.fullScreen,
    maxWidth = _ref.maxWidth,
    fullWidth = _ref.fullWidth,
    onChange = _ref.onChange,
    _ref$TransitionProps = _ref.TransitionProps,
    TransitionProps = _ref$TransitionProps === void 0 ? {} : _ref$TransitionProps,
    _ref$disableBackdropC = _ref.disableBackdropClick,
    disableBackdropClick = _ref$disableBackdropC === void 0 ? false : _ref$disableBackdropC,
    _ref$hideBackdrop = _ref.hideBackdrop,
    hideBackdrop = _ref$hideBackdrop === void 0 ? false : _ref$hideBackdrop,
    _ref$disableScrollLoc = _ref.disableScrollLock,
    disableScrollLock = _ref$disableScrollLoc === void 0 ? false : _ref$disableScrollLoc;
  var classes = useStyles();
  var modalRef = (0, _react.useRef)(null);
  var isInternal = (0, _react.useCallback)(function (e) {
    var _modalRef$current, _modalRef$current$con;
    var pointElements = document.elementsFromPoint(e.x, e.y) || [];
    return (modalRef === null || modalRef === void 0 || (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 || (_modalRef$current$con = _modalRef$current.contains) === null || _modalRef$current$con === void 0 ? void 0 : _modalRef$current$con.call(_modalRef$current, e.target)) || Array.from(pointElements).some(function (el) {
      var _modalRef$current2;
      return modalRef === null || modalRef === void 0 || (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.contains(el);
    });
  }, []);
  var handleClose = function handleClose(event, reason) {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }
    if (typeof onClose === "function") {
      onClose(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog["default"], {
    open: open,
    scroll: scroll,
    onClose: handleClose,
    hideBackdrop: hideBackdrop,
    disableScrollLock: disableScrollLock,
    BackdropComponent: _Backdrop["default"],
    BackdropProps: {
      transitionDuration: TRANSITION_DURATION,
      active: active,
      isInternal: isInternal
    },
    "data-cy-labelledby": "scroll-dialog-title",
    "data-cy-describedby": "scroll-dialog-description",
    className: classes.root,
    disableEscapeKeyDown: !active,
    fullScreen: fullScreen,
    maxWidth: maxWidth,
    fullWidth: fullWidth,
    onChange: onChange,
    TransitionProps: _objectSpread({
      onExited: onExited
    }, TransitionProps),
    ref: modalRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-cy": dataCy,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
        loading: loading,
        children: children
      })
    })
  });
};